// src/components/Navbar.js
import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { verifiedPlayer, logoutPlayer, isVerified } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          CanvasMC
        </Link>

        <button 
          className="hamburger" 
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`navbar-menu ${menuOpen ? 'active' : ''}`}>
          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/rules" className="nav-link">Rules</Link>
          {/* <Link to="/leaderboard" onClick={() => setMenuOpen(false)}>Leaderboard</Link> */}
          <Link to="/leaderboards" className="nav-link">Leaderboard</Link>
          <Link to="/map" onClick={() => setMenuOpen(false)}>Live Map</Link>
          
          {isVerified ? (
            <>
              <Link 
                to={`/player/${verifiedPlayer.playerId}/profile`}
                onClick={() => setMenuOpen(false)}
                className="navbar-profile"
              >
                <img 
                  src={`https://visage.surgeplay.com/face/64/${verifiedPlayer.uuid}`}
                  alt={verifiedPlayer.username}
                  className="navbar-avatar"
                />
                {verifiedPlayer.username}
              </Link>
              <button onClick={() => { logoutPlayer(); setMenuOpen(false); }}>
                Logout
              </button>
            </>
          ) : (
            <Link to="/verify" onClick={() => setMenuOpen(false)}>
              <button>Verify Account</button>
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;